// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidenav {
  width: 250px;
  min-width: 250px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: #0b1426;
  padding-top: 1rem;
  position: relative;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
  z-index: 100;
}

.mainCont {
  width: calc(100% - 250px) !important;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mainContClosed {
  width: calc(100% - 68px) !important;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidenavClosed {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 68px;
  min-width: 68px;
  padding-top: 1rem;
  background-color: #0b1426;
  flex-shrink: 0;
  position: relative;
}

.sideitem {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  margin: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  color: #94a3b8;
  text-decoration: none;
  font-size: 1.15rem;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
}

.sideItemchild {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.navItemIconText {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.navItemIconText svg {
  font-size: 1.4rem;
  flex-shrink: 0;
}

.arrowContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.arrowContainer svg {
  font-size: 1.3rem;
}

.linkText {
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.linkTextClosed {
  display: none;
}

.sideitem:hover {
  background-color: rgba(34, 204, 178, 0.12);
  color: #22ccb2;
}

.sideitem.active {
  background-color: #22ccb2;
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(34, 204, 178, 0.3);
}

.menuBtn {
  margin-bottom: 12px;
  color: #94a3b8;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding-right: 16px;
  transition: color 0.2s ease;
}

.menuBtn:hover {
  color: #22ccb2;
}

.foot_head {
  position: absolute;
  bottom: 0;
  right: 0;
  color: rgb(196, 182, 182);
}

.childMenu {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  pointer-events: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.childMenuOpen {
  opacity: 1;
  max-height: 500px;
  overflow: visible;
  pointer-events: auto;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.childMenuSideNav {
  display: flex;
  align-items: center;
  padding: 9px 12px 9px 20px;
  margin: 3px 8px 3px 14px;
  border-radius: 8px;
  cursor: pointer;
  color: #cbd5e1;
  text-decoration: none;
  font-size: 1.08rem;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
}

.childMenuSideNav svg {
  font-size: 1.3rem;
  flex-shrink: 0;
}

.childMenuSideNav:hover {
  background-color: rgba(34, 204, 178, 0.12);
  color: #22ccb2;
}

.childMenuSideNav.active {
  background-color: #22ccb2;
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(34, 204, 178, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/navigation/sidenav/sidenav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;EACjD,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA;EACE,iDAAiD;EACjD,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD","sourcesContent":[".sidenav {\n  width: 250px;\n  min-width: 250px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background-color: #0b1426;\n  padding-top: 1rem;\n  position: relative;\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n  z-index: 100;\n}\n\n.mainCont {\n  width: calc(100% - 250px) !important;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.mainContClosed {\n  width: calc(100% - 68px) !important;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidenavClosed {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 68px;\n  min-width: 68px;\n  padding-top: 1rem;\n  background-color: #0b1426;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.sideitem {\n  display: flex;\n  align-items: center;\n  padding: 10px 14px;\n  margin: 4px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #94a3b8;\n  text-decoration: none;\n  font-size: 1.15rem;\n  font-weight: 600;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n}\n\n.sideItemchild {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.navItemIconText {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.navItemIconText svg {\n  font-size: 1.4rem;\n  flex-shrink: 0;\n}\n\n.arrowContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.arrowContainer svg {\n  font-size: 1.3rem;\n}\n\n.linkText {\n  padding-left: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.linkTextClosed {\n  display: none;\n}\n\n.sideitem:hover {\n  background-color: rgba(34, 204, 178, 0.12);\n  color: #22ccb2;\n}\n\n.sideitem.active {\n  background-color: #22ccb2;\n  color: #ffffff;\n  font-weight: 700;\n  box-shadow: 0 4px 12px rgba(34, 204, 178, 0.3);\n}\n\n.menuBtn {\n  margin-bottom: 12px;\n  color: #94a3b8;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding-right: 16px;\n  transition: color 0.2s ease;\n}\n\n.menuBtn:hover {\n  color: #22ccb2;\n}\n\n.foot_head {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  color: rgb(196, 182, 182);\n}\n\n.childMenu {\n  opacity: 0;\n  max-height: 0;\n  overflow: hidden;\n  pointer-events: none;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.childMenuOpen {\n  opacity: 1;\n  max-height: 500px;\n  overflow: visible;\n  pointer-events: auto;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.childMenuSideNav {\n  display: flex;\n  align-items: center;\n  padding: 9px 12px 9px 20px;\n  margin: 3px 8px 3px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #cbd5e1;\n  text-decoration: none;\n  font-size: 1.08rem;\n  font-weight: 600;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n}\n\n.childMenuSideNav svg {\n  font-size: 1.3rem;\n  flex-shrink: 0;\n}\n\n.childMenuSideNav:hover {\n  background-color: rgba(34, 204, 178, 0.12);\n  color: #22ccb2;\n}\n\n.childMenuSideNav.active {\n  background-color: #22ccb2;\n  color: #ffffff;\n  font-weight: 700;\n  box-shadow: 0 4px 12px rgba(34, 204, 178, 0.25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
